export default __webpack_public_path__ + "static/media/message.efe34dd7.svg";